import { useState } from 'react';

import { IAsset } from 'components/Pages/Admin/shared/ItinerariesItemLanding/Builder/types';
import { handleDownloadDocument } from 'components/shared/Assets/ViewModal/ViewHead';
import api, { baseApiURL } from 'utils/axios';

import { IItemProps } from './types';

export function useItem(props: IItemProps) {
  const { handlePreview } = props;
  const [isDownload, setIsDownload] = useState(false);
  const [isPreview, setIsPreview] = useState(false);

  const getFullFileUrl = async (file: IAsset) => {
    const result = await api.get(`${baseApiURL}/assets/${file.id}/full_url`);
    if (result.status === 200 && result.data?.url) {
      return result.data.url;
    }
  };

  const onDownload = async (enteredFile: IAsset) => {
    try {
      setIsDownload(true);
      const newUrl = await getFullFileUrl(enteredFile);
      handleDownloadDocument({ ...enteredFile, url: newUrl });
    } finally {
      setTimeout(() => setIsDownload(false), 400);
    }
  };

  const onPreview = async (enteredFile: IAsset) => {
    try {
      setIsPreview(true);
      const newUrl = await getFullFileUrl(enteredFile);
      handlePreview({ ...enteredFile, url: newUrl });
    } finally {
      setTimeout(() => setIsPreview(false), 400);
    }
  };

  return { onDownload, onPreview, isDownload, isPreview };
}
